import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../api/axios";

const TIPOS_SOCIO = ["JUBILADO", "JUBILADO B"];
const ROLES_EXCEPCION = ["EMPLEADO"]; // NUEVO

const AdminCuotas = () => {
  const navigate = useNavigate();

  const [alerta, setAlerta] = useState({
    mostrar: false,
    mensaje: "",
    tipo: "success",
  });

  const [cuotas, setCuotas] = useState([]);
  const [loading, setLoading] = useState(true);

  const [mostrarEliminar, setMostrarEliminar] = useState(false);
  const [cuotaEliminar, setCuotaEliminar] = useState(null);

  const [mostrarModal, setMostrarModal] = useState(false);
  const [editando, setEditando] = useState(false);
  const [cuotaId, setCuotaId] = useState(null);

  const [nuevaCuota, setNuevaCuota] = useState({
    nombre: "",
    valor: "",
    tipo: "FIJA",
  });

  // ===============================
  // Estado para excepciones por tipo de socio
  // ===============================
  const [mostrarExcepciones, setMostrarExcepciones] = useState(false);
  const [cuotaExcepciones, setCuotaExcepciones] = useState(null);
  const [excepciones, setExcepciones] = useState({});
  const [cargandoExcepciones, setCargandoExcepciones] = useState(false);
  const [guardandoExcepcion, setGuardandoExcepcion] = useState(null);

  // ===============================
  // NUEVO: Estado para excepciones por rol (empleados)
  // ===============================
  const [mostrarExcepcionesRol, setMostrarExcepcionesRol] = useState(false);
  const [cuotaExcepcionesRol, setCuotaExcepcionesRol] = useState(null); // cuota sobre la que estamos configurando
  const [excepcionesRol, setExcepcionesRol] = useState({});
  // estructura: { EMPLEADO: { aplica: true, valor: "" } }
  const [cargandoExcepcionesRol, setCargandoExcepcionesRol] = useState(false);
  const [guardandoExcepcionRol, setGuardandoExcepcionRol] = useState(null); // rol que se está guardando

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNuevaCuota((prev) => ({ ...prev, [name]: value }));
  };

  const mostrarAlerta = (mensaje, tipo = "success") => {
    setAlerta({
      mostrar: true,
      mensaje,
      tipo,
    });

    setTimeout(() => {
      setAlerta({ mostrar: false, mensaje: "", tipo: "success" });
    }, 3000);
  };

  // Cargar cuotas
  const cargarCuotas = async () => {
    setLoading(true);
    try {
      const response = await axios.get("/cuotasobtener");
      setCuotas(response.data || []);
    } catch (error) {
      console.error("Error al cargar cuotas:", error);
      mostrarAlerta("Error al cargar las cuotas", "danger");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarCuotas();
  }, []);

  // Guardar (crear o editar)
  const guardarCuota = async () => {
    if (!nuevaCuota.nombre.trim() || !nuevaCuota.valor) {
      mostrarAlerta("Nombre y valor son obligatorios", "danger");
      return;
    }

    const url = editando ? `/cuotas/${cuotaId}` : "/crearcuota";
    const method = editando ? "put" : "post";

    try {
      await axios[method](url, {
        ...nuevaCuota,
        valor: parseFloat(nuevaCuota.valor),
      });

      setMostrarModal(false);
      setEditando(false);
      setCuotaId(null);
      setNuevaCuota({ nombre: "", valor: "", tipo: "FIJA" });

      mostrarAlerta(
        editando ? "Cuota actualizada correctamente" : "Cuota creada correctamente"
      );

      cargarCuotas();
    } catch (error) {
      console.error("Error al guardar cuota:", error);
      mostrarAlerta(
        error.response?.data?.mensaje || "Error al guardar la cuota",
        "danger"
      );
    }
  };

  // Preparar edición
  const abrirEditar = (cuota) => {
    setNuevaCuota({
      nombre: cuota.nombre,
      valor: cuota.valor,
      tipo: cuota.tipo,
    });
    setCuotaId(cuota.id);
    setEditando(true);
    setMostrarModal(true);
  };

  // Eliminar cuota
  const confirmarEliminar = (id) => {
    setCuotaEliminar(id);
    setMostrarEliminar(true);
  };

  const eliminarCuota = async () => {
    try {
      const response = await axios.delete(`/cuotas/${cuotaEliminar}`);

      mostrarAlerta(
        response.data.mensaje || "Cuota eliminada correctamente"
      );

      setMostrarEliminar(false);
      setCuotaEliminar(null);

      cargarCuotas();
    } catch (error) {
      console.error("Error al eliminar cuota:", error);

      mostrarAlerta(
        error.response?.data?.mensaje || "Error al eliminar la cuota",
        "danger"
      );

      setMostrarEliminar(false);
    }
  };

  // ===============================
  // Abrir modal de excepciones por TIPO DE SOCIO
  // ===============================
  const abrirExcepciones = async (cuota) => {
    setCuotaExcepciones(cuota);
    setMostrarExcepciones(true);
    setCargandoExcepciones(true);

    const base = {};
    TIPOS_SOCIO.forEach((t) => {
      base[t] = { aplica: true, valor: "" };
    });

    try {
      const response = await axios.get(`/cuotas/${cuota.id}/excepciones`);
      const existentes = response.data || [];

      existentes.forEach((exc) => {
        base[exc.tipo_socio] = {
          aplica: exc.aplica,
          valor: exc.valor !== null ? exc.valor : "",
        };
      });

      setExcepciones(base);
    } catch (error) {
      console.error("Error al cargar excepciones:", error);
      mostrarAlerta("Error al cargar la configuración de excepciones", "danger");
      setExcepciones(base);
    } finally {
      setCargandoExcepciones(false);
    }
  };

  const handleExcepcionChange = (tipo_socio, campo, valor) => {
    setExcepciones((prev) => ({
      ...prev,
      [tipo_socio]: {
        ...prev[tipo_socio],
        [campo]: valor,
      },
    }));
  };

  const guardarExcepcion = async (tipo_socio) => {
    const config = excepciones[tipo_socio];

    setGuardandoExcepcion(tipo_socio);

    try {
      const valorEnviado =
        config.aplica && config.valor !== "" ? parseFloat(config.valor) : null;

      await axios.post(`/cuotas/${cuotaExcepciones.id}/excepciones`, {
        tipo_socio,
        aplica: config.aplica,
        valor: valorEnviado,
      });

      mostrarAlerta(`Configuración de ${tipo_socio} guardada correctamente`);
    } catch (error) {
      console.error("Error al guardar excepción:", error);
      mostrarAlerta(
        error.response?.data?.mensaje || "Error al guardar la configuración",
        "danger"
      );
    } finally {
      setGuardandoExcepcion(null);
    }
  };

  // ===============================
  // NUEVO: Abrir modal de excepciones por ROL (empleados)
  // ===============================
  const abrirExcepcionesRol = async (cuota) => {
    setCuotaExcepcionesRol(cuota);
    setMostrarExcepcionesRol(true);
    setCargandoExcepcionesRol(true);

    // valores por defecto: paga (usa el valor base), sin excepción configurada aún
    const base = {};
    ROLES_EXCEPCION.forEach((r) => {
      base[r] = { aplica: true, valor: "" };
    });

    try {
      const response = await axios.get(`/cuotas/${cuota.id}/excepciones-rol`);
      const existentes = response.data || [];

      existentes.forEach((exc) => {
        base[exc.rol] = {
          aplica: exc.aplica,
          valor: exc.valor !== null ? exc.valor : "",
        };
      });

      setExcepcionesRol(base);
    } catch (error) {
      console.error("Error al cargar excepciones de rol:", error);
      mostrarAlerta("Error al cargar la configuración por rol", "danger");
      setExcepcionesRol(base);
    } finally {
      setCargandoExcepcionesRol(false);
    }
  };

  const handleExcepcionRolChange = (rol, campo, valor) => {
    setExcepcionesRol((prev) => ({
      ...prev,
      [rol]: {
        ...prev[rol],
        [campo]: valor,
      },
    }));
  };

  const guardarExcepcionRol = async (rol) => {
    const config = excepcionesRol[rol];

    setGuardandoExcepcionRol(rol);

    try {
      const valorEnviado =
        config.aplica && config.valor !== "" ? parseFloat(config.valor) : null;

      await axios.post(`/cuotas/${cuotaExcepcionesRol.id}/excepciones-rol`, {
        rol,
        aplica: config.aplica,
        valor: valorEnviado,
      });

      mostrarAlerta(`Configuración de ${rol} guardada correctamente`);
    } catch (error) {
      console.error("Error al guardar excepción de rol:", error);
      mostrarAlerta(
        error.response?.data?.mensaje || "Error al guardar la configuración",
        "danger"
      );
    } finally {
      setGuardandoExcepcionRol(null);
    }
  };

  return (
    <div className="container-fluid bg-light min-vh-100 py-4 px-3 px-md-4 px-lg-5">
      {alerta.mostrar && (
        <div
          className={`alert alert-${alerta.tipo} alert-dismissible fade show shadow position-fixed`}
          style={{ top: "20px", right: "20px", zIndex: 9999, minWidth: "300px" }}
        >
          <div className="d-flex align-items-center">
            <i
              className={`bi me-2 ${
                alerta.tipo === "success"
                  ? "bi-check-circle-fill"
                  : "bi-x-circle-fill"
              }`}
            ></i>
            <span>{alerta.mensaje}</span>
          </div>
          <button
            className="btn-close"
            onClick={() => setAlerta({ ...alerta, mostrar: false })}
          ></button>
        </div>
      )}

      {/* Header */}
      <div className="card shadow-sm border-0 mb-4 border-start border-success border-4 rounded-3">
        <div className="card-body d-flex flex-wrap justify-content-between align-items-center gap-3">
          <div className="d-flex align-items-center gap-3">
            <button
              className="btn btn-outline-success border-0 rounded-circle p-2"
              onClick={() => navigate("/DashboardSecretaria")}
              title="Volver al dashboard"
            >
              <i className="bi bi-arrow-left-short fs-4"></i>
            </button>
            <h4 className="fw-bold mb-0 text-dark">
              <i className="bi bi-currency-dollar me-2 text-success"></i>
              Gestión de Cuotas
            </h4>
          </div>

          <button
            className="btn btn-success d-flex align-items-center gap-2 shadow-sm px-3"
            onClick={() => {
              setEditando(false);
              setNuevaCuota({ nombre: "", valor: "", tipo: "FIJA" });
              setMostrarModal(true);
            }}
          >
            <i className="bi bi-plus-lg"></i>
            Nueva Cuota
          </button>
        </div>
      </div>

      {/* Tabla de cuotas */}
      <div className="card shadow-sm border-0 rounded-3 overflow-hidden">
        <div className="card-body p-0">
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-success" role="status">
                <span className="visually-hidden">Cargando...</span>
              </div>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0">
                <thead className="table-light text-uppercase small text-muted">
                  <tr>
                    <th className="ps-4 border-0">Nombre</th>
                    <th className="border-0">Valor</th>
                    <th className="border-0">Tipo</th>
                    <th className="text-end pe-4 border-0">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {cuotas.length === 0 ? (
                    <tr>
                      <td colSpan={4} className="text-center py-5 text-muted">
                        <i className="bi bi-currency-dollar fs-1 d-block mb-3 text-success opacity-50"></i>
                        No hay cuotas registradas aún
                      </td>
                    </tr>
                  ) : (
                    cuotas.map((c) => (
                      <tr key={c.id}>
                        <td className="ps-4 fw-medium">{c.nombre}</td>
                        <td className="fw-semibold">
                          ${parseFloat(c.valor).toLocaleString("es-CL")}
                        </td>
                        <td>
                          <span className="badge bg-primary rounded-pill px-3 py-2">
                            {c.tipo.replace("_", " ")}
                          </span>
                        </td>
                        <td className="text-end pe-4">
                          <button
                            className="btn btn-sm btn-outline-primary me-2"
                            onClick={() => abrirExcepciones(c)}
                            title="Configurar por tipo de socio (jubilados, etc.)"
                          >
                            <i className="bi bi-people"></i>
                          </button>
                          {/* NUEVO: botón para configurar excepciones por rol (empleados) */}
                          <button
                            className="btn btn-sm btn-outline-warning me-2"
                            onClick={() => abrirExcepcionesRol(c)}
                            title="Configurar por rol (empleados)"
                          >
                            <i className="bi bi-briefcase"></i>
                          </button>
                          <button
                            className="btn btn-sm btn-outline-success me-2"
                            onClick={() => abrirEditar(c)}
                            title="Editar cuota"
                          >
                            <i className="bi bi-pencil"></i>
                          </button>
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => confirmarEliminar(c.id)}
                            title="Eliminar cuota"
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* Modal CREAR / EDITAR */}
      {mostrarModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.55)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content rounded-4 shadow border-0">
              <div className="modal-header border-0 pb-0">
                <h5 className="modal-title fw-bold text-success">
                  {editando ? "Editar Cuota" : "Nueva Cuota"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setMostrarModal(false)}
                ></button>
              </div>

              <div className="modal-body px-4 pb-4">
                <div className="mb-3">
                  <label className="form-label fw-medium">Nombre</label>
                  <input
                    className="form-control"
                    placeholder="Ej: Cuota Mensual"
                    name="nombre"
                    value={nuevaCuota.nombre}
                    onChange={handleChange}
                    autoFocus
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-medium">Valor ($)</label>
                  <input
                    type="number"
                    step="0.01"
                    className="form-control"
                    placeholder="15000.00"
                    name="valor"
                    value={nuevaCuota.valor}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-medium">Tipo</label>
                  <select
                    className="form-select"
                    name="tipo"
                    value={nuevaCuota.tipo}
                    onChange={handleChange}
                  >
                    <option value="FIJA">Fija</option>
                    <option value="SEGURO_VIDA">Seguro de Vida</option>
                    <option value="SEGURO_ADICIONAL">Seguro Adicional</option>
                    <option value="NUCLEO">Núcleo</option>
                  </select>
                </div>
              </div>

              <div className="modal-footer border-0 px-4 pb-4">
                <button
                  className="btn btn-outline-secondary px-4"
                  onClick={() => setMostrarModal(false)}
                >
                  Cancelar
                </button>
                <button
                  className="btn btn-success px-4 d-flex align-items-center gap-2"
                  onClick={guardarCuota}
                >
                  <i className="bi bi-check-lg"></i>
                  {editando ? "Actualizar" : "Guardar"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ===============================
          Modal EXCEPCIONES POR TIPO DE SOCIO
          =============================== */}
      {mostrarExcepciones && cuotaExcepciones && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.55)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content rounded-4 shadow border-0">
              <div className="modal-header border-0 pb-0">
                <h5 className="modal-title fw-bold text-primary">
                  Excepciones: {cuotaExcepciones.nombre}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setMostrarExcepciones(false)}
                ></button>
              </div>

              <div className="modal-body px-4 pb-4">
                <p className="text-muted small mb-3">
                  Valor base (socios GENERAL): $
                  {parseFloat(cuotaExcepciones.valor).toLocaleString("es-CL")}.
                  Configura aquí si otro tipo de socio paga distinto o no paga esta cuota.
                </p>

                {cargandoExcepciones ? (
                  <div className="text-center py-4">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Cargando...</span>
                    </div>
                  </div>
                ) : (
                  TIPOS_SOCIO.map((tipo) => {
                    const config = excepciones[tipo] || { aplica: true, valor: "" };

                    return (
                      <div
                        key={tipo}
                        className="border rounded-3 p-3 mb-3"
                      >
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <strong>{tipo}</strong>

                          <div className="form-check form-switch mb-0">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              checked={config.aplica}
                              onChange={(e) =>
                                handleExcepcionChange(tipo, "aplica", e.target.checked)
                              }
                            />
                            <label className="form-check-label small">
                              {config.aplica ? "Paga esta cuota" : "No paga esta cuota"}
                            </label>
                          </div>
                        </div>

                        {config.aplica && (
                          <div className="mb-2">
                            <label className="form-label small fw-medium">
                              Valor especial ($) <span className="text-muted fw-normal">(opcional)</span>
                            </label>
                            <input
                              type="number"
                              step="0.01"
                              className="form-control form-control-sm"
                              placeholder="Vacío = usa el valor general"
                              value={config.valor}
                              onChange={(e) =>
                                handleExcepcionChange(tipo, "valor", e.target.value)
                              }
                            />
                          </div>
                        )}

                        <button
                          className="btn btn-sm btn-primary w-100"
                          onClick={() => guardarExcepcion(tipo)}
                          disabled={guardandoExcepcion === tipo}
                        >
                          {guardandoExcepcion === tipo ? "Guardando..." : `Guardar ${tipo}`}
                        </button>
                      </div>
                    );
                  })
                )}
              </div>

              <div className="modal-footer border-0 px-4 pb-4">
                <button
                  className="btn btn-outline-secondary px-4"
                  onClick={() => setMostrarExcepciones(false)}
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ===============================
          NUEVO: Modal EXCEPCIONES POR ROL (empleados)
          =============================== */}
      {mostrarExcepcionesRol && cuotaExcepcionesRol && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.55)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content rounded-4 shadow border-0">
              <div className="modal-header border-0 pb-0">
                <h5 className="modal-title fw-bold text-warning">
                  Excepciones por rol: {cuotaExcepcionesRol.nombre}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setMostrarExcepcionesRol(false)}
                ></button>
              </div>

              <div className="modal-body px-4 pb-4">
                <p className="text-muted small mb-3">
                  Valor base: $
                  {parseFloat(cuotaExcepcionesRol.valor).toLocaleString("es-CL")}.
                  Por defecto los empleados pagan esta cuota al valor base.
                  Desactiva el switch si no deben pagarla, o indica un valor especial.
                </p>

                {cargandoExcepcionesRol ? (
                  <div className="text-center py-4">
                    <div className="spinner-border text-warning" role="status">
                      <span className="visually-hidden">Cargando...</span>
                    </div>
                  </div>
                ) : (
                  ROLES_EXCEPCION.map((rol) => {
                    const config = excepcionesRol[rol] || { aplica: true, valor: "" };

                    return (
                      <div
                        key={rol}
                        className="border rounded-3 p-3 mb-3"
                      >
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <strong>{rol}</strong>

                          <div className="form-check form-switch mb-0">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              checked={config.aplica}
                              onChange={(e) =>
                                handleExcepcionRolChange(rol, "aplica", e.target.checked)
                              }
                            />
                            <label className="form-check-label small">
                              {config.aplica ? "Paga esta cuota" : "No paga esta cuota"}
                            </label>
                          </div>
                        </div>

                        {config.aplica && (
                          <div className="mb-2">
                            <label className="form-label small fw-medium">
                              Valor especial ($) <span className="text-muted fw-normal">(opcional)</span>
                            </label>
                            <input
                              type="number"
                              step="0.01"
                              className="form-control form-control-sm"
                              placeholder="Vacío = usa el valor general"
                              value={config.valor}
                              onChange={(e) =>
                                handleExcepcionRolChange(rol, "valor", e.target.value)
                              }
                            />
                          </div>
                        )}

                        <button
                          className="btn btn-sm btn-warning w-100"
                          onClick={() => guardarExcepcionRol(rol)}
                          disabled={guardandoExcepcionRol === rol}
                        >
                          {guardandoExcepcionRol === rol ? "Guardando..." : `Guardar ${rol}`}
                        </button>
                      </div>
                    );
                  })
                )}
              </div>

              <div className="modal-footer border-0 px-4 pb-4">
                <button
                  className="btn btn-outline-secondary px-4"
                  onClick={() => setMostrarExcepcionesRol(false)}
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {mostrarEliminar && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,.55)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content border-0 shadow-lg rounded-4"
              style={{ overflow: "hidden" }}
            >
              {/* Cabecera */}
              <div
                className="text-center py-4"
                style={{ background: "#dc3545" }}
              >
                <div
                  className="bg-white rounded-circle mx-auto d-flex align-items-center justify-content-center"
                  style={{
                    width: "75px",
                    height: "75px",
                  }}
                >
                  <i
                    className="bi bi-trash-fill text-danger"
                    style={{ fontSize: "34px" }}
                  ></i>
                </div>
              </div>

              {/* Contenido */}
              <div className="modal-body text-center px-4 py-4">
                <h4 className="fw-bold mb-3">
                  ¿Eliminar cuota?
                </h4>

                <p className="text-muted mb-0">
                  Esta acción eliminará permanentemente la cuota seleccionada.
                  <br />
                  <strong>Esta acción no se puede deshacer.</strong>
                </p>
              </div>

              {/* Botones */}
              <div className="modal-footer border-0 justify-content-center pb-4">
                <button
                  className="btn btn-light border px-4"
                  onClick={() => {
                    setMostrarEliminar(false);
                    setCuotaEliminar(null);
                  }}
                >
                  Cancelar
                </button>

                <button
                  className="btn btn-danger px-4 d-flex align-items-center gap-2"
                  onClick={eliminarCuota}
                >
                  <i className="bi bi-trash-fill"></i>
                  Sí, eliminar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminCuotas;